import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EmployeeAgreementTemplateComponent } from "./employee-agreement-template.component";

const routes:Routes = [
    { path: '', component: EmployeeAgreementTemplateComponent,       },

  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })

  export class  EmployeeAgreementTemplateRouting{}